import { useEffect, useState } from "react";
import { navItems } from "@/mocks/movieData";

export default function SiteNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
      style={{ height: "var(--nav-height)" }}
    >
      <div className="w-full h-full flex items-center justify-between px-4 md:px-6">
        <a
          href="#top"
          className={`flex items-center gap-2 shrink-0 font-heading font-bold text-lg md:text-xl transition-colors ${
            scrolled ? "text-foreground-950" : "text-background-50"
          }`}
        >
          <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-film-line text-base" aria-hidden="true"></i>
          </span>
          神马电影
        </a>

        <nav className="hidden md:flex items-center gap-1" aria-label="页面分区导航">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={item.href}
              className={`px-3 py-2 rounded-md text-sm font-label whitespace-nowrap transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-700 hover:bg-primary-50"
                  : "text-background-100 hover:text-background-50 hover:bg-white/10"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#lines"
            className={`hidden md:inline-flex items-center gap-2 px-4 py-2 rounded-md text-sm font-label whitespace-nowrap transition-colors ${
              scrolled
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "bg-background-50 text-foreground-950 hover:bg-background-100"
            }`}
          >
            <i className="ri-link-m" aria-hidden="true"></i>
            查看最新地址
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-expanded={open}
            aria-label="展开导航菜单"
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors cursor-pointer ${
              scrolled ? "text-foreground-950 bg-background-100" : "text-background-50 bg-white/15"
            }`}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open ? (
        <div className="md:hidden bg-background-50 border-b border-background-200 px-4 py-3">
          <nav className="grid grid-cols-2 gap-2" aria-label="移动端分区导航">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={item.href}
                onClick={() => setOpen(false)}
                className="px-3 py-2 rounded-md text-sm font-label text-foreground-700 bg-background-100 hover:bg-primary-50 hover:text-primary-700 transition-colors"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      ) : null}
    </header>
  );
}